import { render, staticRenderFns } from "./signModule.vue?vue&type=template&id=456c42c6&scoped=true&"
import script from "./signModule.vue?vue&type=script&lang=js&"
export * from "./signModule.vue?vue&type=script&lang=js&"
import style0 from "./signModule.vue?vue&type=style&index=0&id=456c42c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456c42c6",
  null
  
)

export default component.exports